import Mixin from "../../mixin.js";
import Funnel from "../../services/funnel-service.js";
import Utils from "../../services/utils-service.js";
import Label from "./Label.js";
import Multiselect from 'vue-multiselect'

const template = `
    <div v-show="fs.display(input)">
        <div v-if="input.type != 'hidden'" aria-live="polite" aria-atomic="true" class="sr-only" :id="input.id+'_announcer'"></div>
        <div class="select type_1" v-if="isTypeOne">
            <qt-label :iuid="iuid" :multiselect="this.input.type == 'radio' || (this.input.type == 'checkbox' && input.limit == 1)" :class="computedLabelClass"></qt-label>
            <select
                    :disabled="computedDisable"
                    :id="input.id"
                    :required="input.validation.required"
                    :name="input.element_name"
                    :value="input.value"
                    @change="exec($event, input)"
                    v-bind="validationRules"
                    :class="computedClass"
                    :data-uid="input.uid"
                    :aria-labelledby="'label_'+input.id"
                >
                <option v-for="option in input.options" :selected="option.value == input.value" :value="option.value" v-show="fs.display(option)">{{ option.label }}</option>
            </select>
        </div>
        <div class="card-select type_2" v-if="input.select_type == 2  && this.input.type != 'checkbox'">
            <div class="card">
                <qt-label :iuid="iuid" :img="fs.icon(input)" :class="computedLabelClass"></qt-label>
                <select
                    :disabled="computedDisable"
                    :id="input.id"
                    :required="input.validation.required"
                    :name="input.element_name"
                    :value="input.value"
                    @change="exec($event, input)"
                    v-bind="validationRules"
                    :class="computedClass"
                    :data-uid="input.uid"
                    :aria-labelledby="'label_'+input.id"
                >
                <template v-if="!isOptGroup">
                    <option v-if="checkBlank(input.options)" value=""></option>
                    <option v-if="!isOptGroup" v-for="option in input.options" :value="option.value" :disabled="setDisabled(option.disabled)" v-show="fs.display(option)">{{ option.label }}</option>
                </template>
                <template v-else>
                    <option value=""></option>
                    <optgroup v-if="isOptGroup" v-for="group in input.optgroups" :label="group.label">
                        <option v-for="option in input.optgroupsdata[group.name]" :value="option.value" v-show="fs.display(option)">{{ option.label }}</option>
                    </optgroup>
                </template>
            </select>
            </div>
        </div>
        <div class="select type_3" v-if="isMultiSelect">
             <label
                :label-for="input.id"
                :for="input.id"
                :id="'label_'+iuid"
                :class="computedLabelClass"
            >
                <span>
                   {{ input.label }}
                </span>
            </label>
            <multiselect
                v-model="multiselectValue"
                :options="input.options"
                label="label"
                track-by="value"
                :searchable="false"
                :disabled="computedDisable"
                :id="input.id"
                :required="input.validation.required"
                :name="input.element_name"
                v-bind="validationRules"
                :class="computedClass"
                :multiple="isMultiple"
                :max="input.limit"
                :data-uid="input.uid"
                :aria-labelledby="'label_'+input.id"
              >
                  <template slot="option" slot-scope="{ option }">{{ option.label }}</template>
            </multiselect>
        </div>
    </div>
`;

export default {
    name: 'qt-input-select',
    template,
    props: ['iuid'],
    mixins: [Mixin],
    components: {
        'qt-label': Label,
        'multiselect': Multiselect
    },
    data() {
        return {
            multiselectValue: []
        }
    },
    watch: {
        multiselectValue(newVal, oldVal) {
            if (newVal && newVal != oldVal) {
                this.updateValueAction()
            }
        },
        "input.loading": function (newVal, oldVal) {
           this.fs.elementAnnouncer(this.input)
        },
        "input.options": function (newVal, oldVal) {
            //this.$store.commit('UPDATE_FUNNEL_ELEM', { iuid: this.input.uid, key: 'value', val: ''});
            var self = this
            this.$nextTick(function () {
                self.checkOneOption()
            })
        }
    },
    computed: {
        isMultiple: function () {
            return this.input.type == 'checkbox'
        },
        isTypeOne: function () {
            // console.log(this.input.type, this.input.uid);
            if ((this.input.type == 'select' || this.input.type == 'radio' || this.input.type == 'spinner' || (this.input.type == 'checkbox' && this.input.limit == 1)) && (this.input.select_type != 2 && this.input.select_type != 3)) {
                return true
            }
        },
        isMultiSelect: function () {
            if (this.input.select_type == 3 || this.input.type == 'checkbox' && this.input.limit > 1) {
                return true
            }
        },
        isOptGroup: function () {
            return Utils.isTruthy(this.input.optgroup);
        },
        computedLabelClass: function () {
            var labelClass = []

            if (this.format == 'basic') {
                return '';
            }

            //:class="format == 'basic' ? '' : input.label_class"
            //remember to include the basic conditional in the return string

            if (this.input.value) {
                labelClass.push('complete')
            }

            if (this.input.label_class && !this.multiselect && (this.input.type != 'radio' && this.input.type != 'checkbox')) {
                labelClass.push(this.input.label_class)
            }

            if (this.computedClass) {
                labelClass.push(this.computedClass)
            }

            return labelClass
        },
        computedClass: function () {
            var type_class = []

            if (this.input.select_type) {
                type_class.push(" type_" + this.input.select_type + "_select")
            }
            if (this.input.type == 'radio' || this.input.type == 'checkbox') {

                type_class.push(" type_3_select")
            }
            else {
                type_class.push(" type_1_select")
            }
            if (this.computedDisable) {
                type_class.push(" disabled")
            }
            if (this.input.loading) {
                type_class.push(" loading-button")
            }
            return type_class
        },
        computedDisable: function () {
            if (this.input.options.length <= 1 || this.input.disabled || this.input.loading) {
                if (this.input.options[0] && this.input.options[0].value == "") {
                    // only one and is blank. makes sense for it to be disabled bc it has literally no data
                    return true;
                }

            }
        },
        validationRules: function () {
            // v-bind="validationRules"
            return this.input.validation
        },
        input: function () {
            return this.$store.getters.funnel.elements[this.iuid];
        },
        fs: function () {
            return new Funnel({ ctx: this.$store, router: this.$router });
        },
        // loadingText: function(){
        //     if (this.input.loading) {
        //         return"Dynamic element "+this.input.label+" loading please wait."
        //     }else{
        //         return "Dynamic element "+this.input.label+" loaded please continue."
        //     }
             
        // }
    },
    mounted: function () {
        if (this.input.type == 'checkbox') {
            var self = this;
            // this.multiselectValue == this.input.value
            var selectedOptions = this.input.options.filter(function (option) {
                return option.value.indexOf(self.input.value) > -1
            })

            this.$nextTick(function () {
                this.multiselectValue = selectedOptions
            })
            console.log("onLoad selected option for: " + this.input.uid, selectedOptions);
        }
        var self = this
        this.$nextTick(function () {
            self.checkOneOption()
        })
    },
    methods: {
       
        checkOneOption: function () {
            /* JohnM Note:
            This function unintentionally preselects some single option element dropdowns;
            adding 'skipCheckOneOption' flag to prevent that in the interim.
            */
            if (this.input.options.length > 0 && (this.input.fxn && Utils.isTruthy(this.input.fxn.skipCheckOneOption))) {
                return;
            }
            // AMS
            //Adding else condition to accommodate those options that have only 1 or 2 entries and need the default selected.
            else {
                if (this.input.options.length == 1) {
                    this.$store.commit('UPDATE_FUNNEL_ELEM', { iuid: this.input.uid, key: 'value', val: this.input.options[0].value });
                } else if (this.input.options.length == 2) {
                    this.$store.commit('UPDATE_FUNNEL_ELEM', { iuid: this.input.uid, key: 'value', val: this.input.options[1].value });
                }
            }
        },
        updateValueAction: function () {
            var values = this.multiselectValue.map(a => a.value)

            this.$store.commit('UPDATE_FUNNEL_ELEM', { iuid: this.input.uid, key: 'value', val: values });
        },
        checkBlank: function (options) {
            let status = false;
            if (!this.input.no_blank_first && options.length > 0 && options[0].value != '') {
                status = true;
            }
            return status;
        }
    }
};
